import React from 'react';
import CountUp from 'react-countup';
import sal from 'sal.js';

const StatItem = ({ number, isStatic = false, suffix, label, style = {}, ...rest }) => {
  const statStyle = {
    textAlign: 'center',
    color: 'white',
    padding: '40px 20px',
    flex: 1,
    ...style,
  };

  const numberStyle = {
    fontSize: '48px',
    fontWeight: 'bold',
    fontFamily: 'sans-serif',
  };

  const labelStyle = {
    fontSize: '20px',
    color: '#000',
    letterSpacing: '1.5px',
    textTransform: 'uppercase',
    fontFamily: 'sans-serif',
  };

  return (
    <div style={statStyle} {...rest}>
      <div style={numberStyle}>
        {isStatic ? (
          number
        ) : (
          <CountUp end={Number(number)} duration={2.75} enableScrollSpy scrollSpyOnce />
        )}
        {suffix && <span className="opacity-75">{suffix}</span>}
      </div>
      <div style={labelStyle}>{label}</div>
    </div>
  );
};

const StatsSection = ({ statItems = [] }) => {
  React.useEffect(() => {
    setTimeout(() => sal({ threshold: 0.2, once: true }), 100);
  }, [statItems]);

  return (
    <div className="stats-section">
      <div className="container">
        <div className="stats-wrapper" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
          {statItems.map((item, index) => {
            const isStatic = isNaN(item.value);
            return (
              <StatItem
                className="stat-items"
                key={index}
                number={item.value}
                suffix={item.suffix}
                label={item.label}
                isStatic={isStatic}
                data-sal="fade"
                data-sal-duration="1000"
                data-sal-delay={index * 200}
                style={index === 1 ? { backgroundColor: 'var(--primary-dark-color)' } : {}}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default StatsSection;
